/**
 * Data the prerender step bakes into every static page (client/prerender.js writes it as
 * `<script type="application/json" id="prerendered-page-data">`), so the app's first
 * render can show the same journal settings, page text and announcement as the static
 * HTML it replaces -- instead of placeholders that jump into place when the live
 * requests return a moment later. The live requests still run; this only seeds them.
 *
 * A JSON script block rather than an inline `<script>` assignment because the site's CSP
 * (script-src 'self') blocks inline script execution; JSON blocks are never executed.
 */
export interface PrerenderedPageData {
  settings?: Record<string, unknown>;
  announcement?: { message?: string; link?: string; linkText?: string; isActive?: boolean };
  pageContent?: Record<string, { key: string; heading: string; body: string }[]>;
}

let cached: PrerenderedPageData | null | undefined;

export function readPrerenderedPageData(): PrerenderedPageData | null {
  if (cached !== undefined) return cached;
  cached = null;
  try {
    const el = typeof document !== 'undefined' ? document.getElementById('prerendered-page-data') : null;
    if (el?.textContent) cached = JSON.parse(el.textContent) as PrerenderedPageData;
  } catch {
    cached = null;
  }
  return cached;
}
